import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import chunk from 'lodash/chunk';
import isEqual from 'lodash/isEqual';

import './HorizontalGrid.scss';

class HorizontalGrid extends Component {
  static defaultProps = {
    cellWidth: 'm',
    rows: 1,
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.children, prevProps.children)) {
      if(this.props.children && this.props.children.length>0 && prevProps.children && prevProps.children.length>0 ) {
        var result = this.props.children.filter(function(o1){
          return !prevProps.children.some(function(o2){
              return o1.key === o2.key;
          });
        })
        if(result.length > 0) {
          let el = document.getElementById("featured");
          if(el) el.scrollLeft = 0
        }
      }
    }
  }

  render() {
    const baseClassName = 'pb-horizontal-grid';

    const {
      children,
      rows,
      cellWidth,
      parentClassName,
      id,
      isRtl
    } = this.props;

    const childrenGroupedByRow = chunk(React.Children.toArray(children), rows);

    const classes = {
      [baseClassName]: true,
      [parentClassName]: parentClassName,
      [`${baseClassName}--${cellWidth}`]: cellWidth,
      [`${baseClassName}--rtl`]: isRtl,
    }

    const columnsEls = childrenGroupedByRow.map((col, i) => {
      return (
        <div className={isRtl ? `${baseClassName}__col ${baseClassName}__col--rtl` : `${baseClassName}__col`} key={`col-${i}`}>
        {
          col.map((c, i) => {
            return (
              <div className={`${baseClassName}__cell`} key={`cell-${i}`}>
                {c}
              </div>
            );
          })
        }
        </div>
      );
    });

    return (
      <div className={classNames(classes)}>
        <div className={`${baseClassName}__wrapper`} id={id}>{columnsEls}</div>
      </div>
    );
  }
}

HorizontalGrid.propTypes = {
  children: PropTypes.node,
  rows: PropTypes.number,
  /* Default size is m */
  cellWidth: PropTypes.oneOf([
    'm',
    'l',
    'xl',
    'xxl',
    'book-card',
    'image-card',
    'category-card',
    'default',
  ])
};

export default HorizontalGrid;



// WEBPACK FOOTER //
// ./src/components/HorizontalGrid/HorizontalGrid.jsx